export default "__VITE_ASSET__Bhw2XxDM__"